import Emitter from 'mitt'

type Events = {
  login: null 
  logout: null
  vote: null
  taskUpdate: null
}

const emitter = Emitter<Events>()
export default emitter
/**
 * 9-1 預約官網 第二屏未知版本上線
 * 9-5 預約官網 第二屏已知版本上線
 * 9-10 OB官網上線
 * 9-15 預約官網下線
 */

export const TIMESTAMP_901 = +new Date('2022/9/01')
export const TIMESTAMP_905 = +new Date('2022/9/05 9:00:00')
export const TIMESTAMP_909 = +new Date('2022/9/09')
// TODO:  914 18点 应援活动结束
// export const TIMESTAMP_914 = +new Date('2022/9/14 18:00:00')
export const TIMESTAMP_914 = +new Date('2022/9/13')
export const TIMESTAMP_915 = +new Date('2022/9/14')
export const TIMESTAMP_113 = +new Date('2023/1/13')

export const isBefore901 = () => window.serverTimestamp < TIMESTAMP_901
export const isBefore905 = () => window.serverTimestamp < TIMESTAMP_905
export const isBefore909 = () => window.serverTimestamp < TIMESTAMP_909
export const isBefore914 = () => window.serverTimestamp < TIMESTAMP_914
export const isBefore915 = () => window.serverTimestamp < TIMESTAMP_915
export const isBefore113 = () => window.serverTimestamp < TIMESTAMP_113
